import DemoBanner from "./DemoBanner";
import EmployerDashboardDemo from "@/pages/public/callachap/EmployerDashboardDemo";

/**
 * Care Portal wrapper for the BALM employer utilization dashboard demo.
 * Reuses <EmployerDashboardDemo /> from /callachap/demo/employer without modification.
 * Adds a Care Portal demonstration banner and route context.
 */
export default function CareBalmEmployer() {
  return (
    <div data-testid="care-balm-employer-wrapper">
      <DemoBanner subtitle="Employer administrator view — sample metrics only." />
      <EmployerDashboardDemo />
    </div>
  );
}
